export default {
    team: {
        teamSpace: '团队空间',
        teamSpaceDescription: '创建团队/企业空间，邀请团队成员、企业员工加入。设置不同权限的角色并为成员授权。助力团队协作的同时满足企业精细化的管控需求',
        spaceAndMemberManagement: '空间与成员管理',
        spaceAndMemberManagementDescription: '一键创建专属空间',
        spaceAndMemberManagementDescription2: '便捷邀请企业成员加入',
        spaceAndMemberManagementDescription3: '支持团队共享空间和高效协作',
        quotaManagement: '积分配额管理',
        quotaManagementDescription: '企业积分池按周期自动为成员配额',
        quotaManagementDescription2: '可手动调整成员的企业积分余额',
        quotaManagementDescription3: '支持企业成员按需充值个人积分',
        rolePermissionSetting: '角色权限设置',
        rolePermissionSettingDescription: '支持创建多个企业角色',
        rolePermissionSettingDescription2: '支持设置角色的功能与数据权限',
        rolePermissionSettingDescription3: '支持对企业成员按角色赋权',
        memberManage: '成员管理',
        roleManage: '角色管理',
        enterpriseTotalScore: '企业总积分：',
        searchMember: '输入成员名称或手机号搜索',
        selectRole: '请选择角色',
        allocatePoints: '分配积分',
        setRole: '设置角色',
        removeEnterprise: '移出企业',
        removeTeam: '移出团队',
        inviteNewMember: '邀请新成员',
        createTeam: '创建团队',
        memberName: '成员名称',
        roleName: '角色',
        phoneNumber: '手机号',
        enterpriseScore: '企业积分',
        joinTime: '加入时间',
        operation: '操作',
        copy: '复制',
        join: '通过该链接注册或登录，即可加入企业',
        joinTeam: '通过该链接注册或登录，即可加入团队',
        enterpriseName: '企业名称',
        teamName: '团队名称',
        pleaseEnterName: '请输入名称',
        description: '描述',
        pleaseEnterScore: '请输入分配的积分：',
        score: '积分',
        allocatePointsDescription: '分配后成员的企业积分将变更为调整后的数值，不影响成员充值的个人积分',
        copySuccess: '复制成功',
        modifyImmediately: '修改后立即生效，成员的权限将同步更新，确定修改吗？',
        editRole: '编辑角色',
        setSuccess: '设置成功',
        cancelSetting: '取消设置',
        confirmRemoveEnterprise: '是否确认将该成员移出企业空间？',
        confirmRemoveTeam: '是否确认将该成员移出团队空间？',
      
        removeEnterpriseMember: '移出企业成员',
        removeTeamMember: '移出团队成员',
        removeSuccess: '移出成功',
        cancelRemove: '取消移出',
        pleaseEnterCompanyName: '请输入公司名称',
        modifySuccess: '修改成功',
        createSuccess: '创建成功',
        allocatePointsSuccess: '积分分配成功',
        back: '返回',
        roleNameTip: '角色：',
        menuAndFunctionPermission: '菜单和功能权限',
        dataRangePermission: '数据范围权限',
        nextStep: '下一步',
        previousStep: '上一步',
        submit: '提交',
        menuAndFunctionPermissionTip: '该角色可在系统中查看的菜单',
        dataRangePermissionTip: '该角色可在系统中查看的数据范围',
        permissionSettingNotComplete: '权限设置未完成，取消后无法保存，确定取消吗？',
        tip: '提示',
        saveSuccess: '保存成功',
        pleaseConfigureDataRangePermission: '请配置数据范围权限后保存',
        saveImmediately: '保存后立即生效，已被授予该角色的成员，其权限也将同步更新，确定修改吗？',
        cancelSubmit: '取消提交',
        createRole: '新建角色',
        role: '角色',
        type: '类型',
        creator: '创建人',
        createTime: '创建时间',
        updateTime: '更新时间',
        systemRole: '系统角色',
        customRole: '自定义角色',
      
        deleteRole: '删除角色',

        roleDescriptionTip: '角色描述：',
        pleaseEnterRoleName: '请输入角色名称',
        pleaseEnterRoleDescription: '请输入角色描述',
        deleteRoleTip: '删除后角色不可恢复，确定删除吗？',
        configure: '配置',
    }
}